import { useNavigate, useParams } from "react-router-dom";
import { AdminQueueItemView } from "@/features/admin/review-queue/components/AdminQueueItemView";

/** One item opened from Assigned Items (/admin/assigned-items/:itemId). */
export function AssignedItemPage() {
  const { itemId = "" } = useParams<{ itemId: string }>();
  const navigate = useNavigate();
  const back = () => navigate("/admin/assigned-items");
  return <AdminQueueItemView key={itemId} itemId={itemId} backLabel="Assigned Items" onBack={back} onAssigned={back} />;
}
